<template>
    <div class="admin-preview">
        <div class="a-card pv-bar">
            <button class="a-btn" @click="back">← 返回列表</button>
            <button class="a-btn" :disabled="!page" @click="edit">编辑此页</button>
            <button class="a-btn" :disabled="!isPublished" @click="openSite">在新窗口打开前台</button>
            <span class="grow"></span>
            <span class="pv-meta" v-if="page">
                主题 {{ page.theme }} · 状态 {{ statusLabel(page.status) }} · 浏览 {{ page.viewcount }}
                <template v-if="!isPublished">（未发布，前台暂不可见）</template>
            </span>
        </div>

        <div v-if="loading" class="a-empty">正在加载…</div>
        <div v-else-if="!page" class="a-empty">{{ error || '页面不存在' }}</div>

        <!-- 手机外框 -->
        <div v-else class="phone-wrap">
            <div class="phone">
                <div class="phone-notch"></div>
                <div class="phone-screen" :class="page.theme">
                    <!-- 花瓣（rose 主题） -->
                    <div class="petals" v-if="page.theme === 'rose'">
                        <span v-for="n in 14" :key="n" :style="petalStyle(n)"></span>
                    </div>

                    <div class="screen-inner">
                        <div class="pv-name" v-if="page.nameText">{{ page.nameText }}</div>
                        <h1 class="pv-title">{{ page.title }}</h1>
                        <div class="pv-sub" v-if="page.subtitle">{{ page.subtitle }}</div>
                        <div class="pv-date" v-if="page.date">{{ page.date }}</div>

                        <div class="pv-verses" v-if="verses.length">
                            <div class="pv-verse" v-for="(v, i) in verses" :key="'v' + i">{{ v }}</div>
                            <div class="pv-from" v-if="page.verseFrom">—— {{ page.verseFrom }}</div>
                        </div>

                        <div class="pv-body">
                            <p class="pv-p" v-for="(p, i) in paragraphs" :key="'p' + i">{{ p }}</p>
                        </div>

                        <div class="pv-divider" v-if="page.sign || page.signDate"><span>❦</span></div>
                        <div class="pv-sign">
                            <div class="s-name" v-if="page.sign">{{ page.sign }}</div>
                            <div class="s-date" v-if="page.signDate">——{{ page.signDate }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade">
            <div v-if="toast" class="a-toast" :class="toast.type">{{ toast.text }}</div>
        </transition>
    </div>
</template>

<script>
import { adminApi } from './api';

export default {
    name: 'AdminPreview',
    data() {
        return {
            loading: false,
            page: null,
            error: '',
            toast: null
        };
    },
    computed: {
        verses() {
            return this.page && this.page.verses ? this.page.verses.filter(v => v && v.trim()) : [];
        },
        paragraphs() {
            return this.page && this.page.paragraphs ? this.page.paragraphs.filter(p => p && p.trim()) : [];
        },
        isPublished() {
            return this.page && this.page.status === 1;
        }
    },
    created() {
        const id = this.$route.query.id;
        if (!id) {
            this.error = '缺少页面 id';
            return;
        }
        this.load(id);
    },
    methods: {
        load(id) {
            this.loading = true;
            adminApi
                .page(id, '')
                .then(d => {
                    this.page = d;
                })
                .catch(err => {
                    this.error = err.message;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        statusLabel(s) {
            return { 0: '草稿', 1: '已发布', 2: '已下线' }[s] || '未知';
        },
        petalStyle(n) {
            const left = (n * 37) % 100;
            const delay = ((n * 13) % 60) / 10;
            const dur = 6 + ((n * 7) % 5);
            const size = 8 + ((n * 3) % 8);
            return {
                left: left + '%',
                width: size + 'px',
                height: size * 1.5 + 'px',
                animationDelay: delay + 's',
                animationDuration: dur + 's'
            };
        },
        edit() {
            this.$router.push({ path: '/admin/edit', query: { id: this.page.id } });
        },
        openSite() {
            if (!this.page || !this.page.code) return;
            window.open(window.location.origin + '/#/p/' + this.page.code, '_blank');
        },
        back() {
            this.$router.push('/admin/pages');
        }
    }
};
</script>

<style lang="less" scoped>
.pv-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    margin-bottom: 18px;
    .grow {
        flex: 1;
    }
    .pv-meta {
        font-size: 12.5px;
        color: #8a7360;
    }
}

.phone-wrap {
    display: flex;
    justify-content: center;
    padding: 6px 0 30px;
}

.phone {
    position: relative;
    width: 375px;
    height: 760px;
    padding: 12px;
    box-sizing: border-box;
    background: #2f2620;
    border-radius: 34px;
    box-shadow: 0 22px 50px rgba(80, 55, 30, 0.3);
}
.phone-notch {
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 116px;
    height: 20px;
    background: #2f2620;
    border-radius: 0 0 12px 12px;
    z-index: 5;
}
.phone-screen {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 24px;
    background: linear-gradient(180deg, #fdf3e7 0%, #f9ead8 45%, #f5e2cc 100%);
}

.screen-inner {
    position: relative;
    z-index: 2;
    padding: 46px 22px 40px;
}

.pv-name {
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 7px;
    color: #a3122e;
    margin-bottom: 14px;
}
.pv-title {
    margin: 0;
    font-size: 19px;
    font-weight: 600;
    color: #5b4636;
    line-height: 1.6;
    text-align: center;
}
.pv-sub {
    margin-top: 8px;
    text-align: center;
    font-size: 12.5px;
    color: #b08d6e;
}
.pv-date {
    margin: 14px auto 0;
    width: fit-content;
    padding: 4px 14px;
    font-size: 11.5px;
    color: #b08d6e;
    background: rgba(176, 141, 110, 0.12);
    border-radius: 999px;
}

.pv-verses {
    margin: 22px 0 6px;
    text-align: center;
}
.pv-verse {
    font-family: 'STKaiti', 'KaiTi', '楷体', serif;
    font-size: 16px;
    line-height: 2;
    color: #8a2540;
    letter-spacing: 1px;
}
.pv-from {
    margin-top: 8px;
    font-size: 11.5px;
    color: #b08d6e;
}

.pv-body {
    margin-top: 18px;
}
.pv-p {
    margin: 0 0 16px;
    font-size: 14px;
    line-height: 1.95;
    color: #4a3f35;
    text-align: justify;
    text-indent: 2em;
}

.pv-divider {
    display: flex;
    align-items: center;
    margin: 26px 0 16px;
    &::before,
    &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(176, 141, 110, 0.5));
    }
    &::after {
        background: linear-gradient(90deg, rgba(176, 141, 110, 0.5), transparent);
    }
    span {
        padding: 0 14px;
        color: #c69c7b;
    }
}
.pv-sign {
    text-align: right;
    .s-name {
        font-family: 'STKaiti', 'KaiTi', '楷体', serif;
        font-size: 15px;
        color: #7a5c44;
    }
    .s-date {
        margin-top: 6px;
        font-size: 12px;
        color: #a08a76;
    }
}

/* ---------------- rose 主题 ---------------- */
.phone-screen.rose {
    background: linear-gradient(180deg, #3d0a17 0%, #6b0f28 45%, #8c1130 100%);
    .pv-title {
        color: #ffe6ec;
    }
    .pv-name {
        color: #ff9db3;
    }
    .pv-sub,
    .pv-date,
    .pv-from {
        color: #e0a3b3;
    }
    .pv-date {
        background: rgba(255, 255, 255, 0.12);
    }
    .pv-verse {
        color: #ffd9e2;
    }
    .pv-p {
        color: #f4dbe2;
    }
    .pv-divider span {
        color: #ffb3c4;
    }
    .pv-divider::before {
        background: linear-gradient(90deg, transparent, rgba(255, 180, 200, 0.5));
    }
    .pv-divider::after {
        background: linear-gradient(90deg, rgba(255, 180, 200, 0.5), transparent);
    }
    .pv-sign .s-name {
        color: #ffc9d6;
    }
    .pv-sign .s-date {
        color: #e0a3b3;
    }
}

/* ---------------- plain 主题 ---------------- */
.phone-screen.plain {
    background: #fff;
    .pv-title {
        color: #1f1f1f;
    }
    .pv-name {
        color: #444;
    }
    .pv-verse {
        color: #333;
    }
    .pv-p {
        color: #444;
    }
}

/* ---------------- 花瓣 ---------------- */
.petals {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;
    span {
        position: absolute;
        top: -30px;
        display: block;
        background: radial-gradient(circle at 50% 30%, #ff6b86, #c01033 70%);
        border-radius: 50% 50% 50% 0;
        opacity: 0.75;
        animation-name: petalFall;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
    }
}
@keyframes petalFall {
    0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0;
    }
    10% {
        opacity: 0.8;
    }
    100% {
        transform: translateY(780px) rotate(420deg);
        opacity: 0.15;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
